import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { isUnlinkedAccount, signedInLoginTarget } from '../../utils/profileMissing';
import { LoginScreen } from './LoginScreen';

/**
 * `/login`. A signed-in user is sent on (see `signedInLoginTarget`); a Firebase account with no
 * RosterPilot user but a stored signup is an unfinished signup, sent back to `/signup` to resume
 * rather than into a dashboard that refuses every request. One with no stored signup (removed
 * staff, most often) stays here, and LoginScreen signs it out and says why.
 */
export const LoginRoute = () => {
  const { user } = useAuth();
  const location = useLocation();

  return user && !isUnlinkedAccount(user) ? (
    <Navigate to={signedInLoginTarget(user, location.state)} replace />
  ) : (
    <LoginScreen />
  );
};
